export const sortObjectArray = (objectArray, property, ascending = true) => {
    return (
        objectArray?.sort((previous, current) =>
            (ascending === true) ?
                previous[property] - current[property]
                :
                current[property] - previous[property]
                )
    )
}